<template>
<div class="collection-controls-guest">
    <div class="collection-controls" :class="{ 'list': isList }">

        <button type="button" class="btn btn-outline-secondary me-2 collection-toggle coll-iso" data-bs-toggle="modal"
                data-bs-target="#collectionJoinPP">
            <i class="fa-regular fa-magnifying-glass-plus d-none d-sm-inline d-md-none d-xl-inline"></i> ISO
        </button>
        <button v-if="!isList" type="button" class="btn btn-outline-secondary me-4 collection-toggle coll-grail" data-bs-toggle="modal"
                data-bs-target="#collectionJoinPP">
            <i class="fa-regular fa-crown d-none d-sm-inline d-lg-none d-xl-inline"></i> Grail
        </button>
        <div class="btn-group">
            <button type="button" class="btn btn-outline-secondary collection-toggle coll-own" data-bs-toggle="modal"
                data-bs-target="#collectionJoinPP">
                <i class="fa-regular fa-circle-check d-none d-sm-inline"></i> OWN</button>
            <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split collection-toggle"
                    data-bs-toggle="dropdown">
                <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu">
                <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#collectionJoinPP">Trader</a>
            </div>
        </div>
    </div>

    <div class="modal" id="collectionJoinPP" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Organize Your Collection</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <h6 class="display-6 mb-0">Join PIN &amp; POP <strong>FREE</strong></h6>
                    <p class="text-muted">... and see how easy it is to manage your collection.</p>
                    <p class="fs-6 mt-4">It's like having your own personal database to track items:</p>
                    <ul class="list-group fs-4">
                        <li class="list-group-item text-own">You already <strong>OWN</strong></li>
                        <li class="list-group-item text-iso">You're <strong>In Search Of (ISO)</strong></li>
                        <li class="list-group-item text-trader">You're willing to <strong>TRADE</strong></li>
                        <li class="list-group-item text-grail">Hard-to-find <strong>GRAILS</strong></li>
                    </ul>
                    <p class="fs-6 text-muted mt-2">Additionally, keep track of your multiples, scrappers, artist proofs and more.</p>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                    <a href="/register" type="button" class="btn btn-lg btn-primary text-light shadow"><strong>Join Free</strong></a>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
    export default {
        name: "CollectionControlsGuest",
        props: ['isList'],
        data() {
            return {
                //
            }
        },
        mounted() {
            //
        },
        created() {
            //
        },
        computed: {
            //
        },
        methods: {
            //
        }
    }
</script>